import { TLanguage } from 'config/tenancy';
import { ICustomer, TMinorityStatus } from 'shared/domain/entities';

type TCustomerPaths = ObjectPaths<ICustomer>;

export const COMPLETE_REGISTRATION_ABSENT_FIELDS_BY_TENANCY: Record<
  TLanguage,
  TCustomerPaths[]
> = {
  es: ['address.postalCode', 'guardian.address.postalCode'],
  'es-CR': [
    'address.postalCode',
    'alternativeDocument',
    'guardian.alternativeDocument',
    'guardian.address.postalCode',
  ],
  'es-UY': [],
  pt: [],
};

const NON_ADULT_FIELDS: TCustomerPaths[] = [
  'birthdate',
  'document',
  'alternativeDocument',
  'email',
  'phone',
  'address.postalCode',
  'address.city.id',
  'address.district.id',
  'address.street',
  'address.number',
  'guardian.firstName',
  'guardian.lastName',
  'guardian.document',
  'guardian.alternativeDocument',
  'guardian.birthdate',
  'guardian.phone',
  'guardian.address.postalCode',
  'guardian.address.city.id',
  'guardian.address.district.id',
  'guardian.address.street',
  'guardian.address.number',
];

export const COMPLETE_REGISTRATION_REQUIRED_FIELDS_BY_STATUS: Record<
  TMinorityStatus,
  Array<TCustomerPaths>
> = {
  ADULT: [
    'birthdate',
    'email',
    'document',
    'alternativeDocument',
    'phone',
    'address.city.id',
    'address.district.id',
    'address.number',
    'address.street',
    'address.postalCode',
  ],
  TEEN: NON_ADULT_FIELDS,
  MINOR: NON_ADULT_FIELDS,
};

export type TCustomerFields =
  (typeof COMPLETE_REGISTRATION_REQUIRED_FIELDS_BY_STATUS)[keyof typeof COMPLETE_REGISTRATION_REQUIRED_FIELDS_BY_STATUS][number];
